import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/forum/components/PostUser';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import UserCard from 'flarum/forum/components/UserCard';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import RankingPage from './RankingPage';

function rankColor(r) {
  if (r < 10) return '#9aa0a6';
  if (r < 20) return '#e53935';
  if (r < 30) return '#fb8c00';
  if (r < 40) return '#fdd835';
  if (r < 50) return '#43a047';
  if (r < 60) return '#1e88e5';
  if (r < 80) return '#3949ab';
  return '#8e24aa';
}

function textOn(hex) {
  const r = parseInt(hex.substr(1, 2), 16);
  const g = parseInt(hex.substr(3, 2), 16);
  const b = parseInt(hex.substr(5, 2), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b > 165 ? '#222' : '#fff';
}

function cornerBadge(rank) {
  const col = rankColor(rank);
  return m('span', { className: 'kb-rank-corner', style: `background:${col} !important;color:${textOn(col)} !important;` }, rank);
}

function wrapAvatar(node, rank) {
  if (!node || typeof node !== 'object') return false;
  const children = Array.isArray(node) ? node : node.children;
  if (!children) return false;
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const c = children[i];
      if (c && c.attrs) {
        const cls = c.attrs.className || c.attrs.class || '';
        if (typeof cls === 'string' && cls.indexOf('Avatar') >= 0 && cls.indexOf('kb-avatar-wrap') < 0) {
          children[i] = m('span', { className: 'kb-avatar-wrap' }, [c, cornerBadge(rank)]);
          return true;
        }
      }
      if (wrapAvatar(c, rank)) return true;
    }
    return false;
  }
  if (children.attrs) {
    const cls2 = children.attrs.className || children.attrs.class || '';
    if (typeof cls2 === 'string' && cls2.indexOf('Avatar') >= 0 && cls2.indexOf('kb-avatar-wrap') < 0) {
      node.children = m('span', { className: 'kb-avatar-wrap' }, [children, cornerBadge(rank)]);
      return true;
    }
  }
  return wrapAvatar(children, rank);
}

function rankOf(user) {
  if (!user) return null;
  let rank = user.attribute ? user.attribute('kbRank') : null;
  if (rank == null && user.data && user.data.attributes) rank = user.data.attributes.kbRank;
  return rank;
}

app.initializers.add('kookbob-flarum-rank', () => {
  app.routes['kb.ranking'] = { path: '/ranking', component: RankingPage };

  extend(PostUser.prototype, 'view', function (vdom) {
    try {
      const post = this.attrs && this.attrs.post;
      const user = post && post.user && post.user();
      const rank = rankOf(user);
      if (rank == null) return;
      wrapAvatar(vdom, rank);
    } catch (e) {}
  });

  extend(SessionDropdown.prototype, 'view', function (vdom) {
    try {
      const rank = rankOf(app.session && app.session.user);
      if (rank == null) return;
      wrapAvatar(vdom, rank);
    } catch (e) {}
  });

  // PC: 아이디 드롭다운에 '랭킹' (프로필 아래, 설정 위)
  extend(SessionDropdown.prototype, 'items', function (items) {
    items.add('kbRanking', m(LinkButton, { icon: 'fas fa-trophy', href: app.route('kb.ranking') }, '랭킹'), 75);
  });

  // 프로필 정보 줄(가입일 등)에 '랭킹' + '로그아웃'(본인만)
  extend(UserCard.prototype, 'infoItems', function (items) {
    try {
      items.add('kbRanking', m(Link, { href: app.route('kb.ranking') }, [m('i', { className: 'icon fas fa-trophy' }), ' 랭킹']), -10);
      const u = this.attrs && this.attrs.user;
      const me = app.session && app.session.user;
      if (u && me && u.id() === me.id()) {
        const logoutUrl = app.forum.attribute('baseUrl') + '/logout?token=' + (app.session.csrfToken || '');
        items.add('kbLogout', m('a', { className: 'kb-logout-link', href: logoutUrl }, [m('i', { className: 'icon fas fa-sign-out-alt' }), ' 로그아웃']), -20);
      }
    } catch (e) {}
  });
});
